export default "/public/app-main/static/image/7b725ec8d99e8ead02c9bddc7cc021cc.png";